export const permission = {
  MYMEDAX_WEBALLOCATOR_USE: 'MYMEDAX_WEBALLOCATOR_USE',
  MYMEDAX_PATIENT_CREATE: 'MYMEDAX_PATIENT_CREATE',
  MYMEDAX_PATIENT_READ: 'MYMEDAX_PATIENT_READ',
  MYMEDAX_PATIENT_UPDATE: 'MYMEDAX_PATIENT_UPDATE',
  MYMEDAX_PATIENT_QUESTIONNAIRE_READ: 'MYMEDAX_PATIENT_QUESTIONNAIRE_READ',
  MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN: 'MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN',
  MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN: 'MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN'
};
